module.exports = window["@material-ui/pickers"].MuiPickersUtilsProvider;